import { Cart } from '@medusajs/medusa'

import { PaymentMethodCreateParams } from '@stripe/stripe-js'
import { useContext, useEffect, useMemo, useState } from 'react'

import { CartContext } from '@/modules/Cart/Cart.vm'
import { Customer } from 'stoux-shared-types/models/customer'

export const useViewModel = () => {
    const [clientSecret, setClientSecret] = useState('')
    const {
        userLogged,
        cartActor: [state],
    } = useContext(CartContext)

    const billingAddress = userLogged?.billing_address || null
    const cart = state.context.cart
    const paymentSession = state.context.payment_session
    const _clientSecret: string = paymentSession?.data.client_secret as string

    const paymentBillingAdress = useMemo(
        () => getBillingInfo({ billingAddress, cart }),
        [cart, billingAddress],
    )

    const canShowPaymentForm = Boolean(
        !!cart?.id && !!cart?.total && !!paymentBillingAdress && !!clientSecret,
    )

    useEffect(() => {
        if (!_clientSecret) {
            return
        }

        setClientSecret(_clientSecret)
    }, [_clientSecret])

    return {
        clientSecret,
        canShowPaymentForm,
        paymentBillingAdress,
    }
}

type GetBillingInfoParams = {
    billingAddress: Customer['billing_address'] | null
    cart: Omit<Cart, 'refundable_amount' | 'refunded_total'> | null
}

function getBillingInfo({
    billingAddress,
    cart,
}: GetBillingInfoParams): PaymentMethodCreateParams.BillingDetails | null {
    let address: Customer['billing_address'] | Cart['billing_address'] | null =
        null

    if (billingAddress) {
        address = billingAddress
    }

    if (cart?.shipping_address) {
        address = cart.shipping_address
    }

    if (!address) {
        return null
    }

    const {
        first_name,
        last_name,
        phone,
        address_1,
        address_2,
        city,
        postal_code,
        country_code,
    } = address

    return {
        name: `${first_name} ${last_name}`,
        email: cart?.email,
        phone: phone || '',
        address: {
            city: city || '',
            state: country_code || 'FR',
            country: country_code || 'FR',
            line1: address_1 || '',
            line2: address_2 || '',
            postal_code: postal_code || '',
        },
    }
}
